/* eslint-disable no-case-declarations */
import { drugVariantIsMicro } from 'app/components/customer/steps/Payment/magician/magicianUtils';
import { MagicianSubProducts, MagicianDoseTypes } from 'app/constants/Products';
import BasePriceCalculator from 'app/helpers/productSpecificPriceCalculators/basePriceCalculator';

// Key is a number of months
export const MAGICIAN_SUBSCRIPTION_MONTHLY_COST = {
  [MagicianSubProducts.Semaglutide]: {
    1: 199_99,
    3: 189_99,
    starter_pack: 299_97,
    standard: 99_99,
    micro: 79_99,
  },
  [MagicianSubProducts.Tirzepatide]: {
    1: 299_99,
    3: 279_99,
    starter_pack: 499_98,
    standard: 166_66,
    micro: 149_99,
  },
  [MagicianSubProducts.SemaglutideMicro]: {
    1: 79_99,
  },
  [MagicianSubProducts.TirzepatideMicro]: {
    1: 149_99,
  },
};

export const MAGICIAN_DOSE_TYPE_SUBSCRIPTION_COST = {
  [MagicianDoseTypes.Standard]: {
    1: 99_99,
  },
  [MagicianDoseTypes.Micro]: {
    1: 79_99,
  },
};
class MagicianPriceCalculator extends BasePriceCalculator {
  drugVariant: MagicianSubProducts;
  isOnboarding: boolean;
  crlFeatureEnabledEncloPregWeightLoss: boolean;

  MAGICIAN_LAB_COST = 69_99;
  LEGACY_MAGICIAN_LAB_COST = 65_00;

  constructor(
    includeBB: boolean,
    includeBBonAnotherProtocol: boolean,
    intakeName: string,
    useOwnLab: boolean,
    multiMonthPlan: 1 | 3,
    drugVariant: MagicianSubProducts,
    isOnboarding = false,
    crlFeatureEnabledEncloPregWeightLoss = false,
    subscriptionPaid = false,
    labPaid = false,
    starterPack: boolean,
    doseType: string | null,
  ) {
    super(includeBB, includeBBonAnotherProtocol, intakeName, multiMonthPlan, useOwnLab, subscriptionPaid, labPaid);

    this.drugVariant = drugVariant;
    this.isOnboarding = isOnboarding;
    this.crlFeatureEnabledEncloPregWeightLoss = crlFeatureEnabledEncloPregWeightLoss;
    this.starterPack = starterPack;
    this.doseType = doseType;
    if (!this.doseType) {
      this.doseType = drugVariantIsMicro(this.drugVariant) ? 'micro' : 'standard';
    }
  }

  monthlySubscriptionCost() {
    return MAGICIAN_SUBSCRIPTION_MONTHLY_COST[this.drugVariant][1] + (this.includeBB ? this.BB_PRICE : 0);
  }

  monthlyCost = () => {
    if (this.doseType === 'micro') {
      return MAGICIAN_SUBSCRIPTION_MONTHLY_COST[this.drugVariant][1];
    } else if (this.starterPack) {
      return MAGICIAN_SUBSCRIPTION_MONTHLY_COST[this.drugVariant]['starter_pack'];
    } else {
      return MAGICIAN_SUBSCRIPTION_MONTHLY_COST[this.drugVariant][this.multiMonthPlan];
    }
  };

  subscriptionCost() {
    if (this.subscriptionPaid) return 0;

    if (this.starterPack) {
      return (
        MAGICIAN_SUBSCRIPTION_MONTHLY_COST[this.drugVariant]['starter_pack'] +
        (this.includeBB ? this.BB_PRICE : 0) * this.multiMonthPlan
      );
    }
    if (this.doseType === 'micro') {
      const result = Math.ceil(
        (MAGICIAN_SUBSCRIPTION_MONTHLY_COST[this.drugVariant][1] + (this.includeBB ? this.BB_PRICE : 0)) * 2.5,
      );
      return result;
    }

    return (
      (MAGICIAN_SUBSCRIPTION_MONTHLY_COST[this.drugVariant][this.multiMonthPlan] +
        (this.includeBB ? this.BB_PRICE : 0)) *
      this.multiMonthPlan
    );
  }

  atHomeLabPrice() {
    return this.crlFeatureEnabledEncloPregWeightLoss ? this.MAGICIAN_LAB_COST : this.LEGACY_MAGICIAN_LAB_COST;
  }

  labCost = () => (this.isOnboarding && !this.labPaid && !this.useOwnLab ? this.atHomeLabPrice() : 0);

  totalDueTodayForCurrentProduct = () => this.subscriptionCost() + this.labCost();
}

export default MagicianPriceCalculator;
